import { formatSkills } from "@/helpers/jobs";
import { getCookie, getSiteProps } from "@/utils";
import { getJdUrl } from "@/utils/jobs";
import React, { useEffect } from "react";

import ContentCompressor from "@/components/single-page-registration/job-detail/common/ContentCompressor";
import JobCompany from "@/components/single-page-registration/job-detail/job-company";
import JobDescription from "@/components/single-page-registration/job-detail/job-desc";
import JobEducation from "@/components/single-page-registration/job-detail/job-education";
import JobHeader from "@/components/single-page-registration/job-detail/job-header";
import JobHeaderBg from "@/components/single-page-registration/job-detail/job-headerBg";
import JobHighlight from "@/components/single-page-registration/job-detail/job-highlight";
import JobInfo from "@/components/single-page-registration/job-detail/job-info";
import JobSkills from "@/components/single-page-registration/job-detail/job-skills";
import { getJobDetails } from "@/components/single-page-registration/query";

import Skeleton from "./Skeleton";

type JobDetailProps = {
  isMobile: boolean;
  setJobUrl: (url: string) => void;
  hostname: string;
};

const JobDetail: React.FC<JobDetailProps> = ({
  isMobile,
  setJobUrl,
  hostname,
}) => {
  const { data: jobData, isError, isLoading } = getJobDetails();
  const siteProps = getSiteProps(hostname);
  const siteContext = siteProps?.site_map || "rexmonster";
  const isLoggedIn =
    typeof window !== "undefined" ? !!getCookie("MSSOCLIENT") : false;

  const openJdPage = (jobData: jobDescriptionType) => {
    const getQueryString = () => {
      const vars: { [key: string]: string } = {};
      const url = new URL(window.location.href);
      const queryParams = new URLSearchParams(url.search);

      queryParams.forEach((value, key) => {
        vars[key] = value;
      });

      return vars;
    };

    let domain = getSiteProps(hostname)?.domain || "";
    const redirectUrl = getJdUrl(jobData, domain);
    setJobUrl(redirectUrl);
    // redirect if user is logged in
    if (isLoggedIn) {
      window.location.href = redirectUrl;
    }
  };

  useEffect(() => {
    if (!isLoading) {
      if (jobData) {
        openJdPage(jobData);
      } else if (isError && isLoggedIn) {
        window.location.href = "/seeker/dashboard";
      }
    }
  }, [jobData, isLoading, isError]);

  if (isError) {
    return (
      <h2 className="m-6 text-2xl font-semibold text-gray-600">
        This job has expired
      </h2>
    );
  }

  if (!jobData) {
    return <Skeleton />;
  }

  const { skills = [], itSkills = [] } = jobData;
  const reqdSkillsArray = formatSkills(skills, itSkills);
  const mediaUrl = siteProps?.media_url || "media.foundit.in";
  return (
    <div
      id="jobDetailContainer"
      className="bg-surface-primary-normal md:!border-border-subtle md:!rounded-2xl md:!border md:!border-solid"
    >
      <JobHeaderBg jobData={jobData} mediaUrl={mediaUrl} />
      <JobHeader jobData={jobData} isMobile={isMobile} />
      <JobHighlight
        jobData={jobData}
        isMobile={isMobile}
        siteContext={siteContext}
      />
      <ContentCompressor isMobile={isMobile}>
        <JobDescription jobData={jobData} isMobile={isMobile} />
      </ContentCompressor>
      <JobEducation jobData={jobData} />
      <JobInfo jobData={jobData} isMobile={isMobile} />
      {(skills.length > 0 || itSkills.length > 0) && (
        <JobSkills reqdSkillsArray={reqdSkillsArray} />
      )}
      <JobCompany jobData={jobData} isMobile={isMobile} mediaUrl={mediaUrl} />
    </div>
  );
};

export default JobDetail;
